import React, { useEffect, useState } from 'react'
import { Fancybox } from "@fancyapps/ui/dist/fancybox/fancybox.esm.js";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import '../css/about.css';
import { Link } from 'react-router-dom';
import axios from 'axios';
import helpers from '../helper';
import Meta from './layout/Meta';
import AboutLoader from '../loader/About';
import CmsLoader from '../loader/Cms';
export default function About() {
  Fancybox.bind('[data-fancybox="gallery"]', {});
  const [aboutdata, setAboutdata] = useState();
  const [missiondata, setMissiondata] = useState();
  const [galleries, setGalleries] = useState([]);
  const [specialties, setSpecialty] = useState([]);
  const [pageloader, setPageloader] = useState(false);
  const [cmsloader, setCmsloader] = useState(false);

  useEffect(() => {
    setPageloader(true);
    async function aboutdatafunction() {
      await axios.get(process.env.REACT_APP_API + 'api/getcmsdata/6')
        .then((response) => {
          setAboutdata(response.data.result);
          setPageloader(false);
        });
    }
    aboutdatafunction();
  }, [setAboutdata]);

  useEffect(() => {
    setCmsloader(true);
    async function missiondatafunction() {
      await axios.get(process.env.REACT_APP_API + 'api/getcmsdata/5')
        .then((response) => {
          setMissiondata(response.data.result);
          setCmsloader(false);
        });
    }
    missiondatafunction();

  }, [setMissiondata]);

  useEffect(() => {
    async function galleriesfunction() {
      await axios.get(process.env.REACT_APP_API + 'api/aboutgallery')
        .then((response) => {
          setGalleries(response.data.result.data);
        });
    }
    galleriesfunction();
  }, [setGalleries]);

  useEffect(() => {
    async function fetchSpecialty() {
      await axios.get(process.env.REACT_APP_API + 'api/ourspecialty')
        .then((response) => {
          setSpecialty(response.data.result.data);
        });
    }
    fetchSpecialty();
  }, [setSpecialty]);

  return (
    <>
      <Meta id={2} />
      <main>
        <section className="InnerHead bgthm2">
          <img loading="lazy" src={require("../assets/img/img-bg.svg").default} alt="About Us" className="imgbg" width="1600" height="453" />
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-8 text-center">
                <h1 className="fw-normal text-white">About Us</h1>
                <ol className="breadcrumb m-0 justify-content-center">
                  <li className="breadcrumb-item"><Link to="/"><img src={require("../assets/img/home.svg").default} width="14" height="14" alt="Home" /></Link></li>
                  <li className="breadcrumb-item"><span aria-current="page">About Us</span></li>
                </ol>
              </div>
            </div>
          </div>
        </section>

        <section className="BannerBottom grey">
          {
            pageloader ?
              <AboutLoader />
              :

              <div className="container">
                {
                  aboutdata !== undefined ?
                    <>
                      <div className="text-center">
                        <span className="SubTitle">{aboutdata.title}</span>
                        <h2 className="Heading"><strong>{aboutdata.heading}</strong></h2>
                      </div>
                      <div className="row justify-content-center">
                        <div className="col-lg-9 col-md-10 text-center" dangerouslySetInnerHTML={{ __html: aboutdata.description }} />
                      </div>
                    </>
                    : ''}

                {
                  specialties.length > 0 ?
                    <div className="row mt-5 text-center">
                      {
                        specialties.map((specialties, sp) =>
                          <div className="col-md-4" key={sp}>
                            <div className="card card-body p-4">
                              {
                                helpers.helpers1(specialties.image) ?
                                  <picture>
                                    <img loading="lazy" src={process.env.REACT_APP_API + 'uploads/specialty/' + specialties.image} alt={specialties.title} width="90" height="90" />
                                  </picture>
                                  :
                                  <picture>
                                    <source srcSet={process.env.REACT_APP_API + 'uploads/specialty/webp/' + specialties.image + '.webp'} type="image/webp" />
                                    <source srcSet={process.env.REACT_APP_API + 'uploads/specialty/avif/' + specialties.image + '.avif'} type="image/avif" />
                                    <img loading="lazy" src={process.env.REACT_APP_API + 'uploads/specialty/jpg/' + specialties.image + '.jpg'} alt={specialties.title} width="90" height="90" />
                                  </picture>
                              }
                              <h3 className="h5 fw-bold">{specialties.title}</h3>
                              <p>{specialties.description}</p>
                            </div>
                          </div>
                        )
                      }


                    </div>
                    :
                    ''
                }

              </div>

          }
        </section>


        {
            cmsloader ?
              <CmsLoader />
              :
              missiondata !== undefined ?
                <section className="Home">
                  <div className="container">
                    {missiondata !== undefined ? <span className="SubTitle">{missiondata.title}</span> : ''}
                    <h2 className="Heading">{missiondata.heading}</h2>
                    <div className="row justify-content-center">
                      <div className="col-12 CmsPage">

                        {
                          helpers.helpers1(missiondata.image) ?
                            <picture className="h-auto float-md-end mb-md-5 ms-md-5 col-md-2">
                              <img loading="lazy" src={process.env.REACT_APP_IMAGE + 'uploads/cms/' + missiondata.image} alt="Gallery" className="w-100" width="380" height="480" />
                            </picture>
                            :
                            <picture className="h-auto float-md-end mb-md-5 ms-md-5 col-md-2">
                              <source srcSet={process.env.REACT_APP_IMAGE + 'uploads/cms/webp/' + missiondata.image + '.webp'} type="image/webp" />
                              <source srcSet={process.env.REACT_APP_IMAGE + 'uploads/cms/avif/' + missiondata.image + '.avif'} type="image/avif" />
                              <img loading="lazy" src={process.env.REACT_APP_IMAGE + 'uploads/cms/jpg/' + missiondata.image + '.jpg'} alt="Gallery" className="w-100" width="380" height="480" />
                            </picture>
                        }

                        <div dangerouslySetInnerHTML={{ __html: missiondata.description }} />
                      </div>
                    </div>
                  </div>
                </section>
                :
                ''
        }

        {
          galleries.length > 0 ?
            <section>
              <div className="container">
                <h2 className="Heading">PES Installations Gallery</h2>
                <div className="row">
                  {
                    galleries.map((gallery, g) =>
                      <div className="col-xl-2 col-md-3 lg-sm-4 col-6" key={g}>
                        {
                          helpers.helpers1(gallery.image) ?
                          <a href={process.env.REACT_APP_IMAGE + 'uploads/about/' + gallery.image} className="gallery" data-fancybox="gallery">
                            <picture>
                              <img loading="lazy" src={process.env.REACT_APP_IMAGE + 'uploads/about/' + gallery.image} alt={"Gallery " + g} width="380" height="480" />
                            </picture>
                            </a>
                            :
                            <a href={process.env.REACT_APP_IMAGE + 'uploads/about/jpg/' + gallery.image + '.jpg'} className="gallery" data-fancybox="gallery">
                            <picture>
                              <source srcSet={process.env.REACT_APP_IMAGE + 'uploads/about/webp/' + gallery.image + '.webp'} type="image/webp" />
                              <source srcSet={process.env.REACT_APP_IMAGE + 'uploads/about/avif/' + gallery.image + '.avif'} type="image/avif" />
                              <img loading="lazy" src={process.env.REACT_APP_IMAGE + 'uploads/about/jpg/' + gallery.image + '.jpg'} alt={"Gallery " + g} width="380" height="480" />
                            </picture>
                            </a>
                        }
                      </div>
                    )
                  }
                </div>
              </div>
            </section>
            :
            ''
        }

      </main>
    </>
  )
}
